import { render, staticRenderFns } from "./LinkSlot.vue?vue&type=template&id=731bed7c&"
import script from "./LinkSlot.vue?vue&type=script&lang=js&"
export * from "./LinkSlot.vue?vue&type=script&lang=js&"
import style0 from "./LinkSlot.vue?vue&type=style&index=0&id=731bed7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports